import { render, staticRenderFns } from "./BackupList.vue?vue&type=template&id=4481b1b4"
import script from "./BackupList.vue?vue&type=script&lang=js"
export * from "./BackupList.vue?vue&type=script&lang=js"
import style0 from "./BackupList.vue?vue&type=style&index=0&id=4481b1b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports